var MANIFEST_JS = {
  toggleSwitch: {
    hashed: 'toggle-switch.b959553da98ffd9165e17db01e5b22d5.min.js',
    versioned: 'toggle-switch.min.js'
  },
  tabs: {
    hashed: 'tabs.35d96ec913e09f40785a09586596b5fe.min.js',
    versioned: 'tabs.min.js'
  },
  progressiveImage: {
    hashed: 'progressive-image.81c02bacc19bfb64da7c081b68680da3.min.js',
    versioned: 'progressive-image.min.js'
  },
  progress: {
    hashed: 'progress.cb7a7169a756e16f9d614bc132652abf.min.js',
    versioned: 'progress.min.js'
  },
  popover: {
    hashed: 'popover.ae69d186f3d2ea4afdeaac0c02928f01.min.js',
    versioned: 'popover.min.js'
  },
  modalDialog: {
    hashed: 'modal-dialog.fb02544993e4dadcf2a641665eece1dd.min.js',
    versioned: 'modal-dialog.min.js'
  },
  core: {
    hashed: 'core.b798f5a6158ca9d7a76020eb0ee7432e.min.js',
    versioned: 'core.min.js'
  },
  alertBox: {
    hashed: 'alert-box.59c5c15fc3f789a64155ba4d88a701c3.min.js',
    versioned: 'alert-box.min.js'
  },
  accordion: {
    hashed: 'accordion.dbca55c282f9f857834ee8e055bb3477.min.js',
    versioned: 'accordion.min.js'
  }
};
export { MANIFEST_JS };